export default __webpack_public_path__ + "src/images/packages/palms-on-the-rocks/996cf25d155bc32cd2f0299b02a79fd8-1.jpg";